<div class="binary-icon" [ngClass]="'binary-icon-' + (value ? 'yes': 'no')"><fa-icon [icon]="value ? iconYes : iconNo"></fa-icon></div>
